import styled from 'styled-components';

export const CommentText = styled.p<{ isAuthor: boolean }>`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%; /* 20.02px */
  letter-spacing: 0.17px;
  color: ${({ isAuthor, theme }) => (isAuthor ? theme.palette.common.white : theme.palette.primary.dark)};
  margin: 0px;
  white-space: pre-line;
  word-break: break-word;
`;

export const MentionText = styled.p<{ isAuthor: boolean }>`
  display: inline;
  font-weight: bold;
  font: 14px/20px Roboto;
  letter-spacing: 0px;
  color: ${({ isAuthor, theme }) => (isAuthor ? theme.palette.common.white : theme.palette.primary.main)};
  font-weight: bold;
  margin: 0;
`;

export const MentionLink = styled.a<{ isAuthor: boolean }>`
  font-weight: bold;
  font: 14px/20px Roboto;
  letter-spacing: 0px;
  color: ${({ isAuthor, theme }) => (isAuthor ? theme.palette.common.white : theme.palette.primary.main)};
  font-weight: bold;
  margin: 0;
  text-decoration: none;
`;

export const UrlLink = styled.a<{ isAuthor: boolean }>`
  font: 14px/20px Roboto;
  letter-spacing: 0px;
  color: ${({ isAuthor, theme }) => (isAuthor ? theme.palette.common.white : theme.palette.primary.main)};
  margin: 0;
  text-decoration: underline;
  word-break: break-all;
`;
